import {call, put,takeLatest} from 'redux-saga/effects'
import * as cartService from "../../../services/cartService"
import {
    ADD_TO_CART,
    ADD_TO_CART_SUCCESS,
    ADD_TO_CART_ERROR
}
    from "../../actions/cart";

function* addToCartSaga(action) {
    try {
        const data=yield call(cartService.AddToCart,action.payload)
        yield put({
            type: ADD_TO_CART_SUCCESS,
            payload: data
        });

    } catch(error) {
        console.log(error)
        yield put({
            type: ADD_TO_CART_ERROR,error: error.data
        });
    }
}


export function* addToCartSagaWatcher() {
    yield takeLatest(ADD_TO_CART,addToCartSaga);
}